/** Takes a boolean value and display a string 'Yes' or 'No' */
export const yesNoFormatter = (_row, _cell, value) => value ? 'Yes' : 'No';
//# sourceMappingURL=yesNoFormatter.js.map